import { IndigoDispatch } from 'store/store';
import State from 'store/State';
import Services from 'store/Services';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import { embeddedAppStateActions } from 'embedded/store/embeddedAppStateSlice';
import { buildLogger } from '@instinet-analytics/core-lib';

export const setEmbeddedPortfolioActionAsync =
    (args: {
        symbology: SymbologyValues;
        orderIds: string[];
        positions: PortfolioPosition[];
    }) =>
    async (
        dispatch: IndigoDispatch,
        getState: () => State,
        services: Services
    ) => {
        const {
            orderValidationApi: api,
            requestProgressService,
            loggingService,
        } = services;
        const { symbology, orderIds, positions } = args;

        const logger = buildLogger(
            'setEmbeddedPortfolioActionAsync',
            loggingService
        );

        if (orderIds.length === 0) {
            dispatch(
                embeddedAppStateActions.setPositions({
                    symbology,
                    values: positions,
                })
            );
            dispatch(embeddedAppStateActions.setAlerts([]));
            return;
        }

        const validOrderIds =
            await requestProgressService.invokeAndMonitorRequest(
                'validateOrderIds',
                (options) => api.validateOrderIds(orderIds, options)
            );

        logger.debug('Handing setPortfolio input', { args, validOrderIds });

        if (validOrderIds.length > 0) {
            dispatch(
                embeddedAppStateActions.setOrderIds({
                    orderIds: validOrderIds,
                    source: 'EmbeddedApi',
                })
            );
        } else {
            dispatch(
                embeddedAppStateActions.setPositions({
                    symbology,
                    values: positions,
                })
            );
        }

        if (validOrderIds.length < orderIds.length) {
            const missingOrderIds = orderIds.filter(
                (o) => !validOrderIds.find((i) => i.toString() === o)
            );
            dispatch(
                embeddedAppStateActions.setAlerts([
                    'The following order id(s) are not recognised and will be ignored: ' +
                        missingOrderIds.join(', '),
                ])
            );
        } else {
            dispatch(embeddedAppStateActions.setAlerts([]));
        }
    };
